var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"solo":"","hide-details":"","dense":"","items":_vm.options,"item-value":"value","item-text":"key"},on:{"input":_vm.onInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }